export function clamp(v, max = 1)
{
    return v < 0 ? 0 : v > max ? max : v;
}

export function findCircleCenter(x0, y0, x1, y1, x2, y2)
{
    x1 -= x0
    y1 -= y0
    x2 -= x0
    y2 -= y0

    const z1 = x1 * x1 + y1 * y1
    const z2 = x2 * x2 + y2 * y2
    const d = 2 * (x1 * y2 - x2 * y1)

    if (d === 0)
    {
        return null
    }
    return [
        (z1 * y2 - z2 * y1) / d + x0,
        (x1 * z2 - x2 * z1) / d + y0
    ]
}

export function distance(x0, y0, x1, y1)
{
    const dx = x1 - x0;
    const dy = y1 - y0;

    return Math.sqrt(dx * dx + dy * dy)
}
